import BindingContext from "@odata/BindingContext";
import { getNewItemsMaxId } from "@odata/Data.utils";
import { IPrHealthInsuranceCompanyEntity, IPrPayrollSettingEntity } from "@odata/GeneratedEntityTypes";
import {
    loadHealthInsuranceCompaniesMemoized
} from "@pages/payroll/healthInsuranceCompany/HealthInsuranceCompany.utils";

import { AppContext } from "../../../contexts/appContext/AppContext.types";
import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { FormViewForExtend, IFormViewProps } from "../../../views/formView/FormView";

interface IProps extends IFormViewProps<IPrPayrollSettingEntity, null> {
}

class HealthInsuranceCompanyFormView extends FormViewForExtend<IPrPayrollSettingEntity, IProps> {
    static contextType = AppContext;

    static defaultProps = {
        title: "InsuranceCompanies:HealthInsurance.FormTitle"
    };

    getAdditionalLoadPromise = () => {
        return [
            loadHealthInsuranceCompaniesMemoized({
                storage: this.props.storage,
                context: this.context
            })
        ];
    };

    async onAfterLoad() {
        const storage = this.props.storage;

        const insuranceCompanies = storage.data.additionalResults[0]?.sort((a: IPrHealthInsuranceCompanyEntity, b: IPrHealthInsuranceCompanyEntity) => parseInt(a.HealthInsuranceCompanyCode) - parseInt(b.HealthInsuranceCompanyCode)) || [];

        for (const ic of insuranceCompanies) {
            const existingItem = this.entity.HealthInsuranceCompanies.find(hic => hic.HealthInsuranceCompany.Code === ic.Code);
            if (!existingItem) {
                const newItemsMax = getNewItemsMaxId(this.entity.HealthInsuranceCompanies) + 1;
                const newEntity = BindingContext.createNewEntity(newItemsMax);

                this.entity.HealthInsuranceCompanies.push({
                    ...newEntity,
                    HealthInsuranceCompanyCode: ic.Code,
                    HealthInsuranceCompany: ic
                });
            } else {
                existingItem.HealthInsuranceCompany = ic;
            }
        }

        return super.onAfterLoad();
    }
}

export default withPermissionContext(HealthInsuranceCompanyFormView);